import { render, staticRenderFns } from "./AlertSubUserPayment.vue?vue&type=template&id=bd043f34&scoped=true"
import script from "./AlertSubUserPayment.vue?vue&type=script&lang=ts"
export * from "./AlertSubUserPayment.vue?vue&type=script&lang=ts"
import style0 from "./AlertSubUserPayment.vue?vue&type=style&index=0&id=bd043f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd043f34",
  null
  
)

export default component.exports